<template lang="">
    <footer class="pt-6 mt-10 bg-enriqueto_green">
        <div class="container p-3 pb-10 mx-auto md:flex justify-center">
            <div class="text-center flex justify-center">
                <a href="https://www.instagram.com/enriquetofrutas/" class="block m-2 text-white w-20 text-center"><img class=" w-7 mb-6 mx-auto" src="/images/ig.png" alt=""></a>
                <a href="https://www.linkedin.com/in/enriqueto-frutas-y-verduras-785492209/" class="block m-2 text-white w-20 text-center"><img class=" w-7 mb-6 mx-auto" src="/images/linkedin.png" alt=""></a>
                <a href="https://twitter.com/enriquetofrutas" class="block m-2 text-white w-20 text-center"><img class=" w-7 mb-6 mx-auto" src="/images/twitter.png" alt=""></a>
            </div>
        </div>
        <div class="p-1 bg-enriqueto_green">
            <div class="container py-3 mx-auto flex justify-center">
                <p class="text-xs text-white flex align-middle text-center items-center"><img class=" bg-enriqueto_yellow w-5 m-1 rounded-sm" src="/images/icon_enriqueto.png" alt=""> © {{year}} Enriqueto. Todos los derechos reservados.</p>
            </div>
        </div>
    </footer>
</template>
<script setup>
import { Link } from '@inertiajs/inertia-vue3'
import { computed } from 'vue'
import { useStore } from 'vuex'

const year = new Date().getFullYear()
const store = useStore()

const dark_mode = computed(() => store.state.dark_mode);
</script>
<style lang="">
    
</style>